import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { Message } from 'semantic-ui-react';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import localStore from 'store';
import LoadingDataEnhancer from './LoadingData';
import withPagination from './WithPagination';
import Search from '../views/Subscription/Search';
import SubscriptionsList from '../views/Subscription/List';
import SubscriptionNew from '../views/Subscription/NewForm';
import SubscriptionEdit from '../views/Subscription/EditForm';

import subscriptionQuery from '../graphql/subscriptionQuery';
import createSubscriptionsMutation from '../graphql/createSubscriptionsMutation';
import updateSubscriptionsMutation from '../graphql/updateSubscriptionsMutation';
import {
  setSearch,
  resetSearch,
  clearSearch,
} from '../data/searchField/actions';
import { clearPage, setPage } from '../data/page/actions';
import { setRefreshSearch } from '../data/refreshSearch/actions';
import { setDealerActive, resetDealerActive } from '../data/subscription/actions';

import { setCustomerNotes } from '../data/customerNotes/actions';
import client from '../apollo';
import activeDealerTypeQuery from '../graphql/activeDealerTypeQuery';
import SubscriptionPreferences from '../views/Subscription/Preferences/Form';
import updatePreferencesMutation from '../graphql/updatePreferencesMutation';
import SubscriptionNotesForm from '../views/Subscription/SubscriptionNotesForm';

import notesQuery from '../graphql/notesQuery';
import createCustomerNotesMutation from '../graphql/createCustomerNotesMutation';
import updateCustomerNotesMutation from '../graphql/updateCustomerNotesMutation';
import deleteCustomerNotesMutation from '../graphql/deleteCustomerNotesMutation';
import { BUYER_SUBSCRIPTION_TYPE, SELLER_SUBSCRIPTION_TYPE } from '../constants/subscriptions';
import { MULTI_SUBSCRIPTION_ENABLED } from '../config';

const CUSTOMER_NOTES_TYPES = 'SUBSCRIPTION';

const CREATE_CUSTOMER_NOTES_MUTATION_NAME = 'createCustomerNotes';
const UPDATE_CUSTOMER_NOTES_MUTATION_NAME = 'updateCustomerNotes';
const DELETE_CUSTOMER_NOTES_MUTATION_NAME = 'deleteCustomerNotes';

const pagingStyle = {
  background: 'white',
  position: 'absolute',
  right: '2.56%',
  paddingTop: '14px',
  fontSize: '15px',
  zIndex: '1',
};

function dateFormat() {
  return 'YYYY-MM-DD';
}

// eslint-disable-next-line no-unused-vars
function getYesterday() {
  const yesterday = moment(new Date(), dateFormat()).subtract(1, 'd');
  return yesterday.format(dateFormat());
}

// eslint-disable-next-line no-unused-vars
function getNextDay() {
  const nextDay = moment(new Date(), dateFormat()).add(1, 'd');
  return nextDay.format(dateFormat());
}

function isExistedPartnerChannel({ ruleSetList, ruleList, innerRuleSetList }) {
  const rsItems = ruleSetList
    .map(rs => rs.items)
    .join(',')
    .split(',');
  const uidIR = innerRuleSetList
    .filter(ir => rsItems.includes(ir.uid))
    .map(ir => ir.uid);
  const RSItemsNotIncludeIR = rsItems.filter(rsI => !uidIR.includes(rsI));
  const isExistedPartnerChannelResult = ruleList.filter(
    rl => RSItemsNotIncludeIR.includes(rl.uid)
      && rl.ruleType === 'PARTNER_CHANNEL'
  );
  return isExistedPartnerChannelResult.length > 0;
}

function handleDuplicatedErrorMsg(errors) {
  const splitMsg = errors.split('.. ');
  const filterMsg = [...new Set(splitMsg)];
  return filterMsg.map(item => item !== '' && item + '.. ');
}

function validDealerNoRange(dealerNo) {
  const REGEX_5MIL_DEALER_NUMBER = /^5[0-9]{6}$/i;
  const REGEX_100MIL_DEALER_NUMBER = /^1[0-9]{8}$/i;
  const regex = REGEX_5MIL_DEALER_NUMBER.test(dealerNo)
    || REGEX_100MIL_DEALER_NUMBER.test(dealerNo);
  return regex;
}

function hasAllSubscriptionTypes(subscriptions) {
  const now = moment();
  const existing = subscriptions.filter(
    s => s.active || (isEmpty(s.endDate) && moment(s.startDate).isSameOrAfter(now, 'day'))
  );
  const hasBuyer = existing.some(s => s.subscriptionType === BUYER_SUBSCRIPTION_TYPE);
  const hasSeller = existing.some(s => s.subscriptionType === SELLER_SUBSCRIPTION_TYPE);
  return hasBuyer && hasSeller;
}

class Subscriptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubscription: null,
      isEditModalOpen: false,
      editFormError: null,
      editFormSubmitting: null,
      flashMessage: null,
      isNewModalOpen: false,
      newFormError: null,
      newFormSubmitting: false,
      isConfirmationPopup: true,
      invalidDealerNumber: false,
      isDisable: true,
      isOpenPopup: false,
      notFoundSubscription: false,
      isPreferencesModalOpen: false,
      preferencesFormError: null,
      preferencesFormSubmitting: false,
      isNotesModalOpen: false,
      notesFormSubmitting: null,
      notesFormError: null,
      isCustomerNotesFlashMessage: false,
      customerNotesAction: 'Create',
      dealerNumberTemp: '',
    };

    const {
      clearSearchFields,
      dispatchRefreshSearch,
      refreshSearch,
      data,
    } = props;

    if (refreshSearch) {
      dispatchRefreshSearch(false);
      clearSearchFields({});
      const variableArguments = {
        dealerNumber: '',
      };
      data.refetch({
        ...variableArguments,
      });
      localStore.remove('flashMessage');
    }
  }

  componentDidMount() {
    const {
      refreshSearch,
      dispatchRefreshSearch,
      data,
      clearSearchFields,
    } = this.props;

    if (refreshSearch) {
      dispatchRefreshSearch(false);
      data.refetch({ dealerNumbers: '', ...(MULTI_SUBSCRIPTION_ENABLED && { view: 'all' }) });
      clearSearchFields({});
    }
    const storedFlashMessage = localStore.get('flashMessage');
    if (!isEmpty(storedFlashMessage)) {
      this.setState({ flashMessage: storedFlashMessage });
    }
  }

  handleMessageDismiss = () => {
    this.setState({ flashMessage: null, isCustomerNotesFlashMessage: false });
  };

  onSelectSubscription = (action, subscription) => {
    this.setState({
      selectedSubscription: subscription,
    });

    switch (action) {
      case 'Edit':
        this.setState({
          isEditModalOpen: true,
          isNewModalOpen: false,
        });
        break;

      case 'Enable Subscription':
        this.enableOrDisableHandler('enabled', subscription);
        break;

      case 'Disable Subscription':
        this.enableOrDisableHandler('expired', subscription);
        break;

      case 'Preferences':
        this.setState({
          isPreferencesModalOpen: true,
          isNewModalOpen: false,
          isEditModalOpen: false,
          preferencesFormError: null,
        });
        break;
      case 'Edit Notes':
        this.setState({
          isNotesModalOpen: true,
          isCustomerNotesFlashMessage: true,
        });
        break;
      default:
        this.setState({
          selectedSubscription: null,
          isCustomerNotesFlashMessage: false,
        });
    }
  };

  onNewFormCloseHandler = () => {
    this.setState({
      isNewModalOpen: false,
      newFormSubmitting: false,
      newFormError: null,
      isConfirmationPopup: false,
    });
  };

  onEditFormCloseHandler = () => {
    this.setState({
      isEditModalOpen: false,
      selectedSubscription: null,
      editFormError: null,
      editFormSubmitting: null,
    });
  };

  onPreferencesFormCloseHandler = () => {
    this.setState({
      isPreferencesModalOpen: false,
      preferencesFormError: null,
      preferencesFormSubmitting: false,
      selectedSubscription: null,
    });
  };

  enableOrDisableHandler = (actionName, subscription) => {
    const { updateMutation, data, setPage: setPageProp } = this.props;
    const subscriptionInput = { subscription: { ...subscription } };
    subscriptionInput.subscription.sameDayPriceUpdate = false;
    subscriptionInput.subscription.priceStartDate = '';

    switch (actionName) {
      case 'enabled':
        subscriptionInput.subscription.startDate = moment().format(
          dateFormat()
        );
        subscriptionInput.subscription.endDate = '';
        break;
      case 'expired': {
        const startDate = moment(subscription.startDate, dateFormat());
        if (
          moment(new Date(), dateFormat()).isSameOrBefore(startDate, 'day')
        ) {
          this.setState({
            flashMessage:
              'Unable to end a same-day or future inactive subscription',
          });
          return false;
        }
        subscriptionInput.subscription.startDate = startDate.format(
          dateFormat()
        );
        subscriptionInput.subscription.endDate = moment().format(
          dateFormat()
        );

        break;
      }
      default:
        return false;
    }
    delete subscriptionInput.subscription.__typename;

    updateMutation({
      variables: { subscriptionInput },
    })
      .then(({ data: responseData }) => {
        const {
          updateSubscriptions: { success, errors },
        } = responseData;
        if (success) {
          this.setState({
            flashMessage: `Successfully ${actionName} Subscription.`,
            invalidDealerNumber: false,
            notFoundSubscription: false,
          });
          data.refetch().then(refetchResult => {
            const subscriptions = get(refetchResult, 'data.subscription') || [];
            this.setState({ isDisable: MULTI_SUBSCRIPTION_ENABLED ? hasAllSubscriptionTypes(subscriptions) : true });
          });
          setPageProp({});
        } else {
          this.setState({
            flashMessage: errors,
            invalidDealerNumber: false,
            notFoundSubscription: true,
            isDisable: true,
          });
        }
      })
      .catch(error => {
        this.setState({
          flashMessage: error.message,
        });
      });
    return true;
  };

  onPreferencesFormSubmitHandler = () => {
    const { selectedSubscription } = this.state;
    const {
      updatePreferencesMutation: updatePreferences,
      data,
      setPage: setPageProp,
    } = this.props;
    const preference = localStore.get('preference') || {};
    const preferenceInput = { preference: localStore.get('preference') } || {};

    if (isExistedPartnerChannel(preference) === false) {
      this.setState({
        preferencesFormError:
          'PARTNER_CHANNEL is required for a preference. Please assure it is set properly',
        preferencesFormSubmitting: false,
      });
      return false;
    }

    delete preferenceInput.preference.__typename;
    preferenceInput.preference.ruleSetList = JSON.stringify(
      preferenceInput.preference.ruleSetList.map(rs => {
        return Object.keys(rs)
          .filter(rsKey => rsKey !== '__typename')
          .reduce((obj, key) => {
            obj[key] = rs[key]; // eslint-disable-line no-param-reassign
            return obj;
          }, {});
      })
    );
    preferenceInput.preference.ruleList = JSON.stringify(
      preferenceInput.preference.ruleList.map(rs => {
        return Object.keys(rs)
          .filter(rsKey => rsKey !== '__typename')
          .reduce((obj, key) => {
            obj[key] = rs[key]; // eslint-disable-line no-param-reassign
            return obj;
          }, {});
      })
    );
    preferenceInput.preference.innerRuleSetList = JSON.stringify(
      preferenceInput.preference.innerRuleSetList.map(rs => {
        return Object.keys(rs)
          .filter(rsKey => rsKey !== '__typename')
          .reduce((obj, key) => {
            obj[key] = rs[key]; // eslint-disable-line no-param-reassign
            return obj;
          }, {});
      })
    );

    preferenceInput.preference.id = parseInt(
      selectedSubscription.subscription_id,
      10
    );

    this.setState({
      preferencesFormSubmitting: true,
    });
    updatePreferences({
      variables: { preferenceInput },
    })
      .then(({ data: responseData }) => {
        const {
          updatePreferences: { success, errors },
        } = responseData;
        if (success) {
          this.setState({
            preferencesFormSubmitting: false,
            preferencesFormError: null,
            isPreferencesModalOpen: false,
            flashMessage: 'Successfully Updated Preferences.',
          });
          data.refetch();
          setPageProp({});
          this.onPreferencesFormCloseHandler();
        } else {
          const prefixErrs = 'Preference Rule has errors.';
          const convertPrefixErrsToArray = [...(prefixErrs + ' ')];
          const errs = handleDuplicatedErrorMsg(
            errors[0].replace(prefixErrs, '')
          );

          this.setState({
            preferencesFormSubmitting: false,
            preferencesFormError: [...convertPrefixErrsToArray, ...errs],
          });
        }
      })
      .catch(error => {
        this.setState({
          preferencesFormSubmitting: false,
          preferencesFormError: Array.isArray(error) ? error : error.message,
        });
      });
    return true;
  };

  onNewFormSubmitHandler = ({ subscription, ...rest }) => { // eslint-disable-line no-unused-vars
    const { createMutation, data, setPage: setPageProp } = this.props;
    const subscriptionInput = { subscription: { ...rest } };
    this.setState({
      newFormSubmitting: true,
    });
    createMutation({
      variables: { subscriptionInput },
    })
      .then(({ data: responseData }) => {
        const {
          createSubscriptions: { success, errors },
        } = responseData;
        if (success) {
          data.refetch();
          setPageProp({});
          this.onNewFormCloseHandler();
          client
            .query({
              query: activeDealerTypeQuery,
              variables: {
                dealerNo: rest.dealerNumber.toString(),
              },
              fetchPolicy: 'network-only',
            })
            .then(async({ data: activeDealerData }) => {
              await this.researchFunction(
                activeDealerData,
                rest.dealerNumber.toString(),
                'created'
              );
            })
            .catch(() => {
              // console.log(errors);
            });
        } else {
          this.setState({
            newFormSubmitting: false,
            newFormError: errors,
          });
        }
      })
      .catch(error => {
        this.setState({
          newFormSubmitting: false,
          newFormError: Array.isArray(error) ? error : error.message,
        });
      });
  };

  onEditFormSubmitHandler = values => {
    const { updateMutation, data, setPage: setPageProp } = this.props;
    const subscriptionInput = { subscription: { ...values } };

    this.setState({
      editFormSubmitting: true,
    });
    updateMutation({
      variables: { subscriptionInput },
    })
      .then(({ data: responseData }) => {
        const {
          updateSubscriptions: { success, errors },
        } = responseData;
        if (success) {
          this.setState({
            editFormSubmitting: false,
            flashMessage: 'Successfully Updated Subscription.',
          });
          data.refetch();
          setPageProp({});
          this.onEditFormCloseHandler();
        } else {
          this.setState({
            editFormSubmitting: false,
            editFormError: errors,
          });
        }
      })
      .catch(error => {
        this.setState({
          editFormSubmitting: false,
          editFormError: Array.isArray(error) ? error : error.message,
        });
      });
  };

  onSearchSubmitHandler = async event => {
    event.preventDefault();
    const {
      resetDealerActive: resetDealerActiveProp,
      setSearchFields,
    } = this.props;
    const { dealerNumbers } = event.target;
    const dealerNo = isEmpty(dealerNumbers.value) ? '' : dealerNumbers.value;
    const variableArguments = {
      dealerNumbers: dealerNo,
    };
    resetDealerActiveProp();
    try {
      if (validDealerNoRange(dealerNo)) {
        const { data: activeDealer } = await client.query({
          query: activeDealerTypeQuery,
          variables: {
            dealerNo,
          },
          fetchPolicy: 'network-only',
        });
        const { data: customerNotes } = await client.query({
          query: notesQuery,
          variables: {
            customerNo: dealerNo + '',
            type: CUSTOMER_NOTES_TYPES,
          },
          fetchPolicy: 'network-only',
        });
        await this.researchFunction(activeDealer, dealerNo, 'searched');
        await this.updateCustomerNotes(customerNotes);
      } else {
        localStore.remove('flashMessage');
        setSearchFields(variableArguments);
        this.setState({
          isDisable: true,
          invalidDealerNumber: true,
          flashMessage: '',
        });
        return false;
      }
    } catch (e) {
      localStore.remove('flashMessage');
      setSearchFields(variableArguments);
      if (validDealerNoRange(dealerNo)) {
        this.setState({
          invalidDealerNumber: false,
          isDisable: false,
          notFoundSubscription: true,
          flashMessage: '',
        });
      } else {
        this.setState({
          invalidDealerNumber: true,
          isDisable: true,
          notFoundSubscription: false,
          flashMessage: '',
        });
      }
    }
    return true;
  };

  researchFunction = async(data, dealerNos, action) => {
    const {
      setDealerActive: setDealerActiveProp,
      data: dataProp,
      setSearchFields,
      setPage: setPageProp,
    } = this.props;
    const result = get(data, 'activeDealer');

    const status = !isEmpty(result) ? result.subscriptionStatus : '';
    const dealerName = !isEmpty(result) ? result.dealerName : '';
    const dealerOnIsl = !isEmpty(result) && result.dealerOnIsl !== null
      ? result.dealerOnIsl
      : false;
    const activeOrInactive = status === 'ACTIVE' || status === 'INACTIVE';
    if (action === 'created') {
      localStore.set('flashMessage', 'Successfully Created Subscription.');
    } else {
      localStore.remove('flashMessage');
    }
    const variableArguments = {
      dealerNumbers: dealerNos + '',
      ...(MULTI_SUBSCRIPTION_ENABLED && { view: 'all' }),
    };
    this.setState({ dealerNumberTemp: dealerNos + '' });
    setDealerActiveProp({
      isDealerOnIsl: dealerOnIsl,
      dealerName,
      dealerNumber: dealerNos + '',
    });
    if (activeOrInactive) {
      const refetchResult = await dataProp.refetch({
        ...variableArguments,
      });

      setSearchFields(variableArguments);
      setPageProp({});
      const subscriptions = get(refetchResult, 'data.subscription') || [];
      const allTypesTaken = MULTI_SUBSCRIPTION_ENABLED ? hasAllSubscriptionTypes(subscriptions) : true;
      this.setState(prevState => ({
        isDisable: allTypesTaken,
        invalidDealerNumber: false,
        notFoundSubscription: false,
        flashMessage: action === 'created' ? prevState.flashMessage : '',
      }));
    } else {
      setSearchFields(variableArguments);
      this.setState(prevState => ({
        isDisable: false,
        invalidDealerNumber: false,
        notFoundSubscription: true,
        flashMessage: action === 'created' ? prevState.flashMessage : '',
      }));
      return false;
    }
    return true;
  };

  onNewSubscription = () => {
    this.setState({
      isNewModalOpen: true,
      isEditModalOpen: false,
    });
  };

  onCloseConfirmationHandler = () => {
    this.setState({
      isNewModalOpen: false,
      newFormSubmitting: false,
      newFormError: null,
      isConfirmationPopup: false,
    });
  };

  onContinueCreateSubscription = () => {
    this.setState({
      isNewModalOpen: true,
      newFormSubmitting: false,
      newFormError: null,
      isConfirmationPopup: false,
    });
  };

  // start process for customer notes
  buildCustomerInput = values => {
    const { user, searchFields } = this.props;
    return {
      customerNotes: {
        updatedBy: user.email,
        customerNo: searchFields.dealerNumbers,
        type: 'SUBSCRIPTION',
        ...values,
      },
    };
  };

  onNotesFormCloseHandler = () => {
    this.setState({
      isNotesModalOpen: false,
      notesFormError: null,
      isCustomerNotesFlashMessage: false,
    });
  };

  onNotesFormSubmitHandler = async values => {
    const {
      createCustomerNotesMutation: createCustomerNotes,
      updateCustomerNotesMutation: updateCustomerNotes,
      deleteCustomerNotesMutation: deleteCustomerNotes,
      customerNotes,
    } = this.props;
    const { customerNotesAction } = this.state;
    this.startSubmitNotes(); // reset some state for customer notes
    try {
      switch (customerNotesAction) {
        case 'Create':
          await this.onExecuteMutationustomerNotes(
            createCustomerNotes,
            CREATE_CUSTOMER_NOTES_MUTATION_NAME,
            values,
            null
          );
          break;
        case 'Update':
          await this.onExecuteMutationustomerNotes(
            updateCustomerNotes,
            UPDATE_CUSTOMER_NOTES_MUTATION_NAME,
            values,
            customerNotes
          );
          break;
        case 'Clear':
          await this.onExecuteMutationustomerNotes(
            deleteCustomerNotes,
            DELETE_CUSTOMER_NOTES_MUTATION_NAME,
            values,
            customerNotes
          );
          break;
        default:
          break;
      }
    } catch (error) {
      this.onFailedSubmitNotes(Array.isArray(error) ? error : error.message);
    }
  };

  handleNotesFormStateChange = action => {
    const { customerNotesAction } = this.state;
    if (customerNotesAction !== action) {
      this.setState({ customerNotesAction: action });
    }
  };

  startSubmitNotes = () => {
    this.setState({
      notesFormSubmitting: true,
      notesFormError: null,
    });
  };

  successSubmitNotes = action => {
    this.setState({
      notesFormSubmitting: false,
      notesFormError: null,
      flashMessage: `Successfully ${action} Customer Notes.`,
    });
  };

  onFailedSubmitNotes = errorMessage => {
    this.setState({
      notesFormSubmitting: false,
      notesFormError: errorMessage,
    });
  };

  handleRefetchCustomerNotes = async() => {
    const { searchFields, setCustomerNotes: setCustomerNotesProp } = this.props;
    try {
      const { data: customerNotes } = await client.query({
        query: notesQuery,
        variables: {
          customerNo: searchFields.dealerNumbers + '',
          type: CUSTOMER_NOTES_TYPES,
        },
        fetchPolicy: 'network-only',
      });
      const result = get(customerNotes, 'customerNotes');
      setCustomerNotesProp(result);
    } catch (error) {
      this.onFailedSubmitNotes(Array.isArray(error) ? error : error.message);
    }
  };

  updateCustomerNotes = data => {
    const { setCustomerNotes: setCustomerNotesProp } = this.props;
    const result = get(data, 'customerNotes');
    setCustomerNotesProp(result);
  };

  getCustomerMutationInput = (values, customerNotes) => {
    const { customerNotesAction } = this.state;
    switch (customerNotesAction) {
      case 'Create':
        return { CreateCustomerNotesInput: this.buildCustomerInput(values) };
      case 'Update':
        return {
          UpdateCustomerNotesInput: {
            ...this.buildCustomerInput({
              ...values,
              noteId: customerNotes.noteId,
            }),
          },
        };
      case 'Clear':
        return { DeleteCustomerNotesInput: { id: customerNotes.noteId || 0 } };
      default:
        return {};
    }
  };

  getNotesButtonText = () => {
    const { customerNotesAction } = this.state;
    if (customerNotesAction === 'Clear') {
      return 'Removed';
    }
    return `${customerNotesAction}d`;
  };

  onExecuteMutationustomerNotes = async(
    mutation,
    mutationResultName,
    values,
    customerNotes
  ) => {
    const input = this.getCustomerMutationInput(values, customerNotes);
    await mutation({
      variables: { ...input },
    })
      .then(({ data }) => {
        const { success, msg } = data[mutationResultName];
        if (success) {
          this.successSubmitNotes(this.getNotesButtonText());
          this.handleRefetchCustomerNotes();
          this.onNotesFormCloseHandler();
          if (mutationResultName === DELETE_CUSTOMER_NOTES_MUTATION_NAME) {
            this.setState({ customerNotesAction: 'Create' });
          }
        } else {
          this.onFailedSubmitNotes(msg);
        }
      })
      .catch(error => {
        this.onFailedSubmitNotes(Array.isArray(error) ? error : error.message);
      });
  };

  // end process for customer notes

  showDealer = () => {
    const dealerName = this.getDealerName();
    const dealerNumber = this.getDealerNumber();

    if (isEmpty(dealerNumber) && isEmpty(dealerName)) {
      return '';
    } if (!isEmpty(dealerNumber) && isEmpty(dealerName)) {
      return dealerNumber;
    }
    return `${dealerNumber} - ${dealerName}`;
  };

  getDealerNumber = () => {
    const { subscriptionDealer } = this.props;
    const { dealerNumberTemp } = this.state;
    if (!isEmpty(subscriptionDealer.dealerNumber)) {
      return subscriptionDealer.dealerNumber;
    } if (!isEmpty(dealerNumberTemp)) {
      return dealerNumberTemp;
    }
    return '';
  };

  getDealerName = () => {
    const { subscriptionDealer } = this.props;
    if (!isEmpty(subscriptionDealer.dealerName)) {
      return subscriptionDealer.dealerName;
    }
    return '';
  };

  render() {
    const {
      selectedSubscription,
      isEditModalOpen,
      editFormError,
      editFormSubmitting,
      isNewModalOpen,
      newFormError,
      newFormSubmitting,
      flashMessage,
      invalidDealerNumber,
      isOpenPopup,
      isDisable,
      notFoundSubscription,
      isPreferencesModalOpen,
      preferencesFormError,
      preferencesFormSubmitting,
      isNotesModalOpen,
      notesFormSubmitting,
      notesFormError,
      isCustomerNotesFlashMessage,
      isConfirmationPopup,
    } = this.state;

    const {
      data: { subscription },
      searchFields,
      subscriptionDealer,
      customerNotes,
    } = this.props;
    const { isDealerOnIsl } = subscriptionDealer;
    const { dealerName } = subscriptionDealer;
    const { dealerNumber } = subscriptionDealer;

    const newSubscription = [];
    newSubscription.push({
      dealerNumber: dealerNumber + '',
      dealerName: dealerName + '',
      productId: 1,
      productName: '',
      subscriptionType: '',
      priceDs: null,
      pricePsiLpi: null,
      notifyEmail: '',
      networkPlusRate: null,
      startDate: null,
      endDate: null,
    });
    const newSubscriptionData = !isEmpty(subscription)
      && subscription[0].dealerNumber === parseInt(dealerNumber, 10)
      ? subscription
      : newSubscription;

    const sortedSubscription = subscription
      .slice()
      .filter(sub => sub.active === false)
      .sort((a, b) => (moment(new Date(a.endDate)).format('YYYY-MM-DD')
        > moment(new Date(b.endDate)).format('YYYY-MM-DD')
        ? -1
        : 1));

    let subscriptionsContent;

    if (invalidDealerNumber) {
      subscriptionsContent = (
        <div>
          <p style={{ color: 'red' }}>Must be a valid Dealer Number</p>
          <SubscriptionsList
            subscriptions={[]}
            dealerInfo={this.showDealer()}
          />
          <div style={pagingStyle}>
            <div>
              <span>
                Showing <b>0 - 0</b>&nbsp;&nbsp;
              </span>
              <button
                type='button'
                className='ui green icon inverted disabled button'
                disabled='disabled'
                tabIndex='-1'
                aria-label='Previous page'
              >
                <i aria-hidden='true' className='caret left icon' />
              </button>
              <button
                type='button'
                className='ui green icon inverted disabled button'
                disabled='disabled'
                tabIndex='-1'
                aria-label='Next page'
              >
                <i aria-hidden='true' className='caret right icon' />
              </button>
              <br />
            </div>
          </div>
        </div>
      );
    } else if (notFoundSubscription) {
      subscriptionsContent = (
        <div>
          <SubscriptionsList
            isDisable={!!isDealerOnIsl}
            dealerInfo={this.showDealer()}
          />
          <div style={pagingStyle}>
            <div>
              <span>
                Showing <b>0 - 0</b>&nbsp;&nbsp;
              </span>
              <button
                type='button'
                className='ui green icon inverted disabled button'
                disabled='disabled'
                tabIndex='-1'
                aria-label='Previous page'
              >
                <i aria-hidden='true' className='caret left icon' />
              </button>
              <button
                type='button'
                className='ui green icon inverted disabled button'
                disabled='disabled'
                tabIndex='-1'
                aria-label='Next page'
              >
                <i aria-hidden='true' className='caret right icon' />
              </button>
              <br />
            </div>
          </div>
        </div>
      );
    } else {
      subscriptionsContent = (
        <SubscriptionsList
          onSelectSubscription={this.onSelectSubscription}
          subscriptions={subscription}
          isDisable={!!isDealerOnIsl}
          customerNotes={customerNotes}
          dealerInfo={this.showDealer()}
        />
      );
    }

    return (
      <div>
        {flashMessage
          && !isCustomerNotesFlashMessage
          && !isEmpty(subscription) && (
            <Message
              onDismiss={this.handleMessageDismiss}
              content={flashMessage}
              positive
            />
        )}
        {flashMessage && isCustomerNotesFlashMessage && (
          <Message
            onDismiss={this.handleMessageDismiss}
            content={flashMessage}
            positive
          />
        )}
        {isEmpty(subscription)
          && !isEmpty(dealerNumber)
          && !invalidDealerNumber
          && !notFoundSubscription && <Message>No Records found</Message>}

        {notFoundSubscription && !invalidDealerNumber && (
          <Message>No Records found</Message>
        )}

        {isDealerOnIsl && (
          <Message color='red'>
            This dealer is currently on the ISL. Please contact Audit team for
            further information.
          </Message>
        )}

        <Search
          onSubmit={this.onSearchSubmitHandler}
          searchFields={searchFields}
          searchOptions={['dealerNumbers']}
          onNewSubscription={this.onNewSubscription}
          isDisabledBtn={!!(isDealerOnIsl || isDisable)}
        />
        {subscriptionsContent}

        {(isOpenPopup || isNewModalOpen) && (
          <SubscriptionNew
            isModalOpen={isNewModalOpen}
            onCloseHandler={this.onNewFormCloseHandler}
            onSubmitHandler={this.onNewFormSubmitHandler}
            error={newFormError}
            submitting={newFormSubmitting}
            subscription={newSubscriptionData}
            onOpenConfirmationPopup={isOpenPopup}
            onNewSubscription={this.onNewSubscription}
            onCloseConfirmationPopup={this.onCloseConfirmationHandler}
            onContinueCreateSubscription={this.onContinueCreateSubscription}
            isConfirmationPopup={isConfirmationPopup}
            dealerInfo={this.showDealer()}
            existingSubscriptionTypes={MULTI_SUBSCRIPTION_ENABLED
              ? subscription
                .filter(s => s.active || (isEmpty(s.endDate) && moment(s.startDate).isSameOrAfter(moment(), 'day')))
                .map(s => s.subscriptionType)
              : []}
          />
        )}

        {selectedSubscription && isEditModalOpen && (
          <div>
            <SubscriptionEdit
              isModalOpen={isEditModalOpen}
              onCloseHandler={this.onEditFormCloseHandler}
              onSubmitHandler={this.onEditFormSubmitHandler}
              subscription={selectedSubscription}
              subscriptions={sortedSubscription}
              error={editFormError}
              submitting={editFormSubmitting}
            />
          </div>
        )}

        {selectedSubscription && isPreferencesModalOpen && (
          <SubscriptionPreferences
            isModalOpen={isPreferencesModalOpen}
            onCloseHandler={this.onPreferencesFormCloseHandler}
            onSubmitHandler={this.onPreferencesFormSubmitHandler}
            subscription={selectedSubscription}
            error={preferencesFormError}
            submitting={preferencesFormSubmitting}
          />
        )}

        {isNotesModalOpen && (
          <SubscriptionNotesForm
            isModalOpen={isNotesModalOpen}
            onCloseHandler={this.onNotesFormCloseHandler}
            onSubmitHandler={this.onNotesFormSubmitHandler}
            onStateChange={this.handleNotesFormStateChange}
            error={notesFormError}
            submitting={notesFormSubmitting}
            customerNotes={customerNotes}
          />
        )}
      </div>
    );
  }
}

Subscriptions.propTypes = {
  clearSearchFields: PropTypes.func.isRequired,
  dispatchRefreshSearch: PropTypes.func.isRequired,
  refreshSearch: PropTypes.bool,
  data: PropTypes.shape({
    refetch: PropTypes.func.isRequired,
    subscription: PropTypes.array,
  }).isRequired,
  updateMutation: PropTypes.func.isRequired,
  createMutation: PropTypes.func.isRequired,
  updatePreferencesMutation: PropTypes.func.isRequired,
  createCustomerNotesMutation: PropTypes.func.isRequired,
  updateCustomerNotesMutation: PropTypes.func.isRequired,
  deleteCustomerNotesMutation: PropTypes.func.isRequired,
  setSearchFields: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  resetDealerActive: PropTypes.func.isRequired,
  setDealerActive: PropTypes.func.isRequired,
  setCustomerNotes: PropTypes.func.isRequired,
  searchFields: PropTypes.object,
  user: PropTypes.object,
  subscriptionDealer: PropTypes.object,
  customerNotes: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
  setPage: () => {
    dispatch(setPage());
  },
  clearSearchFields: () => {
    dispatch(clearSearch());
  },
  resetSearchFields: field => {
    dispatch(resetSearch(field));
  },
  dispatchRefreshSearch: value => {
    dispatch(setRefreshSearch(value));
  },
  clearPage: () => {
    dispatch(clearPage());
  },
  setDealerActive: value => {
    dispatch(setDealerActive(value));
  },
  resetDealerActive: () => {
    dispatch(resetDealerActive());
  },
  setCustomerNotes: field => {
    dispatch(setCustomerNotes(field));
  },
});

const mapStateToProps = state => {
  const {
    data: {
      searchFields,
      refreshSearch,
      subscriptionDealer,
      customerNotes,
      user,
    },
  } = state;
  return {
    searchFields,
    refreshSearch,
    subscriptionDealer,
    customerNotes,
    user,
  };
};

export default compose(
  withRouter,
  withPagination(subscriptionQuery, 'subscription', MULTI_SUBSCRIPTION_ENABLED ? { view: 'all' } : {}),
  graphql(createSubscriptionsMutation, { name: 'createMutation' }),
  graphql(updateSubscriptionsMutation, { name: 'updateMutation' }),
  graphql(updatePreferencesMutation, { name: 'updatePreferencesMutation' }),
  graphql(notesQuery, { name: 'notesQuery' }),
  graphql(createCustomerNotesMutation, { name: 'createCustomerNotesMutation' }),
  graphql(updateCustomerNotesMutation, { name: 'updateCustomerNotesMutation' }),
  graphql(deleteCustomerNotesMutation, { name: 'deleteCustomerNotesMutation' }),
  LoadingDataEnhancer,
  connect(mapStateToProps, mapDispatchToProps)
)(Subscriptions);
